var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditmulti(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-width:1.5px;}.cls-1{stroke-linejoin:bevel;}.cls-2{stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-emultiple-edit"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.93617,11.29787v5.65958a2,2,0,0,1-2,2H7.7234a2,2,0,0,1-2-2V4.02128a2,2,0,0,1,2-2H13.617"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.72872,18.95745v1.20744a2,2,0,0,1-2,2H4.516a2,2,0,0,1-2-2V6.22872a2,2,0,0,1,2-2H5.7234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.29888,2.253a1,1,0,0,0-1.41422,0L11.88331,8.25437l.01054.01054L11.79438,11.26a.21258.21258,0,0,0,.22194.22193l2.99506-.09946.01054.01054,6.00135-6.00135a1,1,0,0,0,0-1.41422Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditmulti);
export default __webpack_public_path__ + "static/media/editmulti.1b4830815f5e171764278c8c8cc977be.svg";
export { ForwardRef as ReactComponent };